import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { UserOrderContext } from 'context/context';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import getContentHelpCall from '@kfc-global/react-shared/redux/Actions/HelpAction';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import { Header } from 'organisms/HeaderComponent';
import { Footer } from 'organisms/FooterComponent';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import {
  getHeaderContentData,
  getHeaderData,
  getFooterData,
  isEmptyObject,
  getTenantData,
  getHelpData,
} from 'common/utilities/utils';
import { getCmsClient } from 'common/utilities/cmsClient';
import { GetHelpLandingPage } from 'organisms/GetHelpLanding/';
import { ChannelManager } from 'common/manager';

export const GetHelpContainer = props => {
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const { DISPOSITION_DATA } = START_ORDER_CONSTANTS;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const history = useHistory();
  let segmentedHomePageData = null,
    segmentedMarketingData = null,
    segmentedTenantData = null,
    segmentedHelp = null,
    segmentedFooterData = null;

  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  const dispatch = useDispatch();

  /**
   * Method to open open disposition module
   */
  const onStartOrderClick = () => {
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
  };

  /**
   * method to setup content data for home page config
   */
  const allReducerData = useSelector(data => {
    return {
      homePageContent: data.contentReducer.response || null,
      marketPageContent: data.marketConfigReducer.response || null,
      tenantReducerContent: data.tenantReducer || null,
      getHelpContent: data.helpReducer.helpResponse || null,
    };
  });

  if (allReducerData.marketPageContent && allReducerData.tenantReducerContent && allReducerData.homePageContent) {
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent);
    const { header = {}, tenant = [], footer = {} } = allReducerData.marketPageContent?.headerData || {};
    segmentedMarketingData = getHeaderData(header);
    segmentedFooterData = getFooterData(footer);
    segmentedHelp = getHelpData(allReducerData.getHelpContent);
  }

  useEffect(() => {
    dispatch(
      getMarketConfigContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'marketConfig',
          'fields.location': allReducerData?.tenantReducerContent?.country,
          'fields.channel': ChannelManager.channel,
          include: 5,
        },
      }),
    );
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.pageType': 'HomePage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams,
      }),
    );
  }, [allReducerData?.tenantReducerContent?.country, dispatch, userParams]);

  useEffect(() => {
    dispatch(
      getContentHelpCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'staticLandingPage',
          'fields.page': 'Help',
          include: '5',
        },
      }),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {(isEmptyObject(segmentedMarketingData) && (
        <Header
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantReducerContent}
          userParams={userParams}
        />
      )) ||
        null}
      <StartOrderComponent
        contentData={{
          segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
          contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
        }}
        userParams={userParams}
      />
      {isEmptyObject(segmentedHelp) && (
        <GetHelpLandingPage
          data-testid='get-help-container'
          onStartOrderClick={onStartOrderClick}
          contentData={segmentedHelp}
          history={history}
        />
      )}
      {(isEmptyObject(segmentedFooterData) && (
        <Footer
          history={history}
          contentData={segmentedFooterData}
          tenantReducerData={allReducerData.tenantReducerContent}
        />
      )) ||
        null}
      {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
    </React.Fragment>
  );
};
